import React from 'react';

function WorkExperiences() {
	return (
		<section className="px-4 sm:px-12 md:px-16 max-w-7xl mx-auto">
			<div className="flex flex-col gap-y-4">
				<WorkExperience
					workExperience={{
						title: "Angular Developer",
						fromDate: "July 2020",
						toDate: "November 2022",
						company: "Farway Security",
						description: [
							`Modernized website architecture using Angular/Tailwind CSS. Collaboratedwith product and design teams for new features and improvements.`,
						],
						position: "Mid-level",
						companyAddress: "India (Remote)",
					}}
					reversed
				/>
				<WorkExperience
					workExperience={{
						title: "Full Stack Developer",
						fromDate: "November 2022",
						toDate: "November 2023",
						position: "Intern",
						company: "Iknite Space",
						description: [
							`Developed reusable React components with Tailwind CSS for a responsive and efficient user interface. Migrated legacy JavaScript code to TypeScript to improve code quality and maintainability. Implemented unit and E2E testing to ensure a high-quality user experience.`,
							`Designed and developed RESTful APIs using Golang to power the application's backend logic. Created clear API documentation to facilitate easy integration and understanding by other developers.`,
						],
						companyAddress:
							"Buea, First Trust Building, ground floor",
					}}
				/>
				<WorkExperience
					workExperience={{
						title: "Backend Developer",
						fromDate: "June 2024",
						toDate: "September 2024",
						position: "Mid-Level",
						company: "MIDATLANTIC GROUP",
						description: [
							`As a Senior Backend Engineer, I am responsible for designing, developing, and maintaining robust and scalable backend systems for our company's applications. I leverage Node.js and Express frameworks to build efficient and maintainable APIs, while utilizing PostgreSQL for reliable data storage.`,
							`In addition to technical development, I play a crucial role in project coordination, ensuring seamless collaboration among team members. I also contribute to the creation of comprehensive technical documentation to support development and maintenance efforts. Furthermore, I am responsible for setting up and managing deployment infrastructure guaranteeing the smooth deployment and operation of our applications.`,
						],
						companyAddress: "(Remote)",
					}}
				/>
				<WorkExperience
					workExperience={{
						title: "Full Stack Developer",
						fromDate: "November 2023",
						toDate: "Current",
						position: "Intermediate",
						company: "Iknite Studio",
						description: [
							`As a Senior Backend Engineer, I am responsible for designing, developing, and maintaining robust and scalable backend systems for our company's applications. I leverage Node.js and Express frameworks to build efficient and maintainable APIs, while utilizing PostgreSQL for reliable data storage.`,
							`In addition to technical development, I play a crucial role in project coordination, ensuring seamless collaboration among team members. I also contribute to the creation of comprehensive technical documentation to support development and maintenance efforts. Furthermore, I am responsible for setting up and managing deployment infrastructure guaranteeing the smooth deployment and operation of our applications.`,
						],
						companyAddress:
							"Buea, First Trust Building, ground floor",
					}}
				/>
			</div>
		</section>
	);
}

export default WorkExperiences;

const WorkExperience = ({
	workExperience,
}: {
	workExperience: {
		title: string;
		fromDate: string;
		toDate: string;
		position: string;
		company: string;
		description: string[];
		companyAddress: string;
	};
	reversed?: boolean;
}) => {
	return (
		<div className="bg-white py-5 md:py-10 text-slate-600 p-4 rounded-md shodow-sm hover:shadow-lg">
			<div className="flex flex-col gap-8 aspect">
				<div className="divide-y md:divide-y-0 flex flex-col md:flex-row gap-4">
					<div className="w-full md:w-1/3">
						<div className="md:px-8 md:border-r">
							<h1 className="font-medium text-primary uppercase">
								{workExperience.title}
							</h1>
							<div>
								<p className="text-sm text-slate-500">
									{workExperience.fromDate} -{" "}
									{workExperience.toDate}
								</p>
							</div>
						</div>
					</div>

					<div className="py-4 md:py-0 md:px-8 [flex:_1] text-slate-700">
						<p>
							<span>{workExperience.company}</span>
							{" - "}
							<span>{workExperience.companyAddress}</span>
						</p>
						{workExperience.description.map((p) => (
							<p className="py-2 text-slate-600 font-light md:max-w-[80%]">
								{p}
							</p>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
